// Core
import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Tooltip, Form, Input, InputNumber, Select, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

// App
import { Modal } from '../../../components/modals/antd-modals';
import { RecordViewWrapper } from './Style';
import { Main, TableWrapper, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { gastosListAction } from '../../../redux/clinica/gastos/actionCreator'


const GastosViewPage = () => {
  const dispatch = useDispatch();    
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.GastosCrudReducer.data);
  
  useEffect(() => { 
    // Cuando termina de carga la pagina, se desata esta primera accion
    if (gastosListAction) {
      dispatch(gastosListAction());
    }
  }, [dispatch]);

  const dataSource = []; // Este sera el arreglo de datos que usa la tabla para mostrar el listado de registros

  const onHandleSearch = e => {
    dispatch(gastosListAction(e.target.value));
  };

  if (registros.length)
    registros.map((record, key) => {      
      const { id, descripcion, importe,nombreEmpleado, sucursal, apellidoPaterno } = record; // Aqui se mapean las propiedades/columnas que el API respondera
      return dataSource.push({
        key: key + 1,
        sucursal,
        descripcion,                 
        importe,
        nombreEmpleado: nombreEmpleado + " " + apellidoPaterno,                 
        action: (
          <div className="table-actions">
            <Tooltip title="Editar información" color="#f8f9ac">
              <Link to={`/admin/clinica/gastos/editar/${id}`}>
                <Button>
                  <FeatherIcon icon="edit" />
                </Button>
              </Link>
            </Tooltip>                                             
          </div>
        ),
      });
    });

    // Estas son las columnas que se utilizaran para armar la tabla
  const columns = [
    {
      title: 'Sucursal',
      dataIndex: 'sucursal',
      key: 'sucursal',
    },   
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
    },   
    {
      title: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
    },   
    {
      title: 'Usuario',
      dataIndex: 'nombreEmpleado',
      key: 'nombreEmpleado',
    },   
    {
      title: 'Acciones',
      dataIndex: 'action',
      key: 'action',
      width: '90px',
    },
  ];

  return (
    <RecordViewWrapper>
      <PageHeader
        subTitle={
          <div>
            <Button className="btn-add_new" size="default" key="1" type="primary">
              <Link to="/admin/clinica/gastos/agregar">
                <FeatherIcon icon="plus" size={14} /> <span>Agregar nuevo gasto</span>
              </Link>
            </Button>
          </div>
        }
        buttons={[
          <div key={1} className="search-box">
            <span className="search-icon">
              <FeatherIcon icon="search" size={14} />
            </span>
            <input onChange={onHandleSearch} type="text" name="recored-search" placeholder="Buscar..." />
          </div>,
        ]}
        
        title="GASTOS"
      />
      <Main>
        <Row gutter={15}>
          <Col className="w-100" md={24}>
            <Cards headless>        
              {isLoading ? (
                <div className="spin">
                  <Spin size='large' />
                </div>
              ) : (
                <div>
                  <TableWrapper className="table-data-view table-responsive">
                    <Table
                      pagination={{ pageSize: 40, showSizeChanger: true }}
                      dataSource={dataSource}
                      columns={columns}
                      locale={{ emptyText: 'Sin registros' }}
                    />
                  </TableWrapper>
                </div>
              )}
            </Cards>
          </Col>
        </Row>
      </Main>
    </RecordViewWrapper>
  );
};

export default GastosViewPage;
